'use client';

import Link from 'next/link';
import { Check } from 'lucide-react';

const plans = [
  {
    name: 'Free',
    price: '$0',
    period: '',
    description: 'Try Apprendo with your first conversations',
    features: ['45-min conversations', '5 AI-extracted moments', 'Basic search', 'AI Guide access'],
    cta: 'Start Free',
    href: '/start',
    highlight: false,
  },
  {
    name: 'Plus',
    price: '$29',
    period: '/seat/mo',
    description: 'For growing teams and creators',
    features: ['Unlimited conversations & moments', 'Up to 3 team members', '720p video exports', 'Calendar sync'],
    cta: 'Get Started',
    href: '/login?signup=true',
    highlight: true,
  },
  {
    name: 'Pro',
    price: '$99',
    period: '/seat/mo',
    description: 'For organizations that need more',
    features: ['Everything unlimited', '4K video exports', 'Private sharing & API', 'Unlimited team members'],
    cta: 'Get Started',
    href: '/login?signup=true',
    highlight: false,
  },
];

export default function PricingPreviewSection() {
  return (
    <section id="pricing" className="py-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">Simple pricing</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] text-foreground">
            Start free. Upgrade when your library grows.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-13">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`bg-card border rounded-[16px] p-9 transition-all hover:-translate-y-1 hover:shadow-md relative ${
                plan.highlight
                  ? 'border-[#EF4444] shadow-[0_0_0_1px_#EF4444]'
                  : 'border-border'
              }`}
            >
              {plan.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#EF4444] text-white px-4 py-1 rounded-full text-[12px] font-semibold">
                  Popular
                </div>
              )}
              <div className="text-[18px] font-bold text-foreground mb-1">{plan.name}</div>
              <div className="mb-1">
                <span className="text-[42px] font-bold tracking-[-2px] text-foreground">{plan.price}</span>
                {plan.period && <span className="text-[16px] text-muted-foreground">{plan.period}</span>}
              </div>
              <p className="text-[13px] text-muted-foreground mb-6">{plan.description}</p>
              <ul className="space-y-2 mb-7">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-[14px] text-foreground">
                    <Check className="w-4 h-4 text-[#10B981] flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                href={plan.href}
                className={`block w-full text-center py-3 rounded-full text-[14px] font-semibold transition-all ${
                  plan.highlight
                    ? 'bg-[#EF4444] text-white hover:bg-[#DC2626]'
                    : 'bg-card text-foreground border border-border hover:border-foreground'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
